export const setCookie = (key, value, domain, path) => {
  let cookie = key + '=' + value;
  if (domain) {
    cookie += "; domain=" + domain;
  }
  if (path) {
    cookie += "; path=" + path;
  }
  document.cookie = cookie;
};

export const setPadiWxId = (value) => {
  const currentHost = document.location.origin
  if(currentHost.indexOf('padi.com.cn') >= 0) {
    delCookie('padiWxId', 'padi.com.cn', '/')
    setCookie('padiWxId', value, 'padi.com.cn', '/')
  }else {
    delCookie('padiWxId')
    setCookie('padiWxId', value)
  }
}

export const getCookie = (sKey) => {
  if (!sKey) { return null; }
  /* eslint-disable */
  return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  /* eslint-enable */
};

export const getUnionId = () => {
  return getCookie('padiWxId');
};

export const delCookie = (name, domain, path) => {
  const cookie = getCookie(name);
  if(!cookie) return
  let expires = new Date();
  expires.setTime(expires.getTime() - 1);
  let cookieToRemove = name + "=; expires=" + expires.toUTCString();
  const currentHost = document.location.origin
  if(currentHost.indexOf('localhost') >= 0) {
    document.cookie = cookieToRemove;
    return
  }
  if (domain) {
      cookieToRemove += "; domain=" + domain;
  }
  if (path) {
      cookieToRemove += "; path=" + path;
  }
  document.cookie = cookieToRemove;
}

export const saveStorage = (key, value) => {
  localStorage.setItem(key, value);
}

export const getDataFromStorage = (key) => {
  return localStorage.getItem(key)
}

export const removeDataFromStorage = (key) => {
  return localStorage.removeItem(key)
}
